import React from "react";
import { DP_ERROR, TYPE_MESSAGE } from "../Foundation";
import { inject, observer } from "mobx-react";
import Constants from "../Constants";
import MemberServices from "../../services/MemberService";
import APIS from "../config/APIs";
import StorageHelper from "../StorageHelper";

@inject('SportsStore')
@observer
export default function listenPostMessage(Child) {
    return class extends React.Component {
        constructor(props) {
            super(props);
            this.timerId = null;
            this.enableDP = window.env.dynamicParameterIframeUrl && window.env.enableDynamicParameter;
            this.SportsStore = props.SportsStore;
            this.dpIframeUrl = APIS.getDPIframeURL(`v=${new Date().getTime()}`);
            this.props.SportsStore.updateHasDynamicParameter(!this.enableDP);
            this.state = {
                showIframe: false
            }
        }

        componentWillMount() {
            window.listenEvent("message", this.handleListenMessage);
            this.enableDP && this.pingToDPIframe();
        }

        componentWillUnmount() {
            window.stopListenEvent("message", this.handleListenMessage);
            this.timerId && clearTimeout(this.timerId);
        }

        handleListenMessage = (event) => {
            if (!event.data || typeof event.data !== "string") {
                return
            }
            const { type, data } = JSON.parse(event.data);
            switch (type) {
                case TYPE_MESSAGE.DP:
                    this.handleDynamicParameter(data);
                    break;
                default:
                    break;
            }
        }

        /**
        * Handle dynamic parameter from iframe
        */
        handleDynamicParameter = (data) => {
            const { name, value } = data;
            const previousDynamicParam = localStorage.getItem("_dp");
            if (previousDynamicParam !== name) {
                StorageHelper.removeBrowsersStorage(previousDynamicParam);
            }
            localStorage.setItem("_dp", name);
            StorageHelper.saveBrowsersStorage(name, value)
            this.SportsStore.updateHasDynamicParameter(true);
        };

        /**
        * Handle case of dynamic parameter do not post message
        */
        handleDynamicParameterError = () => {
            const dynamicParameterContainer = Constants.DP_CONTAINER[this.props.LayoutTemplateStore.currentViewContainer] || [];
            if (this.SportsStore.isHasDynamicParameter || !dynamicParameterContainer.includes(this.props.pageContainer))
                return;
            this.SportsStore.updateHasDynamicParameter(true);
            MemberServices.updateReasonDPFailed({ reason: DP_ERROR.NO_RECEIVE_DP_MESSAGE });
        };

        pingToDPIframe = () => {
            MemberServices.pingToDPIframe()
                .then(res => {
                    this.timerId = setTimeout(this.handleDynamicParameterError, window.env.dynamicParameterTimeout);
                    this.setState({ showIframe: true });
                })
                .catch(error => {
                    const reason = error.response ? error.response.statusText : '';
                    this.SportsStore.updateHasDynamicParameter(true);
                    MemberServices.updateReasonDPFailed({ reason });
                });
        }

        render() {
            return (
                <React.Fragment>
                    <Child {...this.props} />
                    {this.state.showIframe && <iframe src={this.dpIframeUrl} className="dp-iframe"></iframe>}
                </React.Fragment>
            );
        }
    };
}


// WEBPACK FOOTER //
// ./src/app/common/decorator/listenPostMessage.js